import React from 'react';
import { EllipsisIcon } from '~svg';
import { Modal } from '../../../common';
import { fileHandlerUrl } from '../../../../utils/consts/server';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import momentjs from 'moment-jalaali';
import './recentNewsCard.scss';

function RcentNewsCard({ newsData, language, index }) {
  const [isShowNews, setIsShowNews] = useState(false),
    { direction, name } = language,
    titleValue = newsData?.title?.[name === 'ar' ? 'en' : name] ?? '---',
    commentValue =
      newsData?.description?.[name === 'ar' ? 'en' : name] ?? '---',
    imageFile = newsData.images[0][name === 'ar' ? 'en' : name];
  return (
    <div
      className="w-100 d-flex justify-content-between align-items-center pb-2 px-0"
      key={`recent-news-${index}`}
    >
      <Modal
        id="licenseImg"
        detailClass={'align-self-start text-third-dark'}
        title={<FormattedMessage id="profile.recentNews" />}
        modalSize={'modal-xl'}
        isOpen={isShowNews}
        onClose={() => {
          setIsShowNews(false);
        }}
      >
        <div className="w-100 d-flex flex-column px-0 py-2 justify-content-start align-items-center">
          <div className="w-100 d-flex flex-column justify-content-start pb-4 mb-4 font-small text-nowrap">
            <div className="text-third text-start">
              <FormattedMessage id="ticket.lastupdate" />
              <span className="px-1">:</span>
              {newsData?.updatedAt && direction === 'rtl'
                ? `${momentjs(newsData?.updatedAt, 'YYYY-M-D').format(
                    'jDD-jMM-jYYYY',
                  )}`
                : newsData?.updatedAt?.split('T')[1].substring(0, 5) || '---'}
            </div>
            <div className="w-100 d-flex flex-row text-start pt-2 text-wrap">
              <div className="text-third">
                <FormattedMessage id="profile.startnewsevent" />
                <span className="px-1">:</span>
                {newsData?.eventStartDate && direction === 'rtl'
                  ? `${momentjs(newsData?.eventStartDate, 'YYYY-M-D').format(
                      'jDD-jMM-jYYYY',
                    )}`
                  : newsData?.eventStartDate || '---'}
              </div>
              <span className="text-third px-2">/</span>
              <div className="text-third">
                <FormattedMessage id="profile.endnewsevent" />
                <span className="px-1">:</span>
                {newsData?.eventEndDate && direction === 'rtl'
                  ? `${momentjs(newsData?.eventEndDate, 'YYYY-M-D').format(
                      'jDD-jMM-jYYYY',
                    )}`
                  : newsData?.eventEndDate || '---'}
              </div>
            </div>
          </div>
          <div className="w-100 d-flex flex-md-row flex-column-reverse justify-content-start pb-2">
            <div className="d-flex flex-column text-start px-2 col py-md-0 py-4">
              <span className="font-huge font-weight-bold">{titleValue}</span>
            </div>
            <div className="col-md-5 w-100 d-flex justify-content-center px-0 default-border-radius-small border border-2 news-image">
              <img
                alt=""
                src={
                  imageFile
                    ? `${fileHandlerUrl}/file/show/${imageFile}`
                    : require('../../../../content/images/common/greece.webp')
                }
                className="w-100 img-responsive px-0 p-2 default-border-radius-small "
              />
            </div>
          </div>
          <div className="w-100 d-flex flex-column justify-content-start px-sm-3 px-2 text-start py-4 border-3 border-top">
            <span className="text-gray font-large">
              <FormattedMessage id="profile.descriptionnews" />
            </span>
            <span className="text-third font-normal pt-2 px-2">
              {commentValue}
            </span>
          </div>
        </div>
      </Modal>
      <div className="d-flex col-10 px-1 flex-row justify-content-start align-items-center h-100">
        <div className="d-flex flex-row col-xl-4 col-lg-6 col-sm-2 col-3 px-0">
          <img
            alt=""
            src={
              imageFile
                ? `${fileHandlerUrl}/file/show/${imageFile}`
                : require('../../../../content/images/common/greece.webp')
            }
            className="rounded img-fluid img-responsive px-0 col-10 recentNews-image"
          />
        </div>
        <div
          className={`${
            direction == 'rtl' ? 'text-right' : 'text-left'
          } d-flex flex-column px-2 col-xl-8 col-lg-6 col-sm-10`}
        >
          <div className="font-xl-msmall font-lg-smaller font-msmall w-100">
            <span className="d-block text-truncate w-100">{titleValue}</span>
          </div>

          <div className="text-third font-xl-msmall font-lg-smaller font-msmall w-100">
            <span className="d-block text-truncate w-100">{commentValue}</span>
          </div>
        </div>
      </div>
      <div
        className={`cursor-pointer col-2 px-0 text-end ${
          direction === 'rtl' ? 'pl-3' : 'pr-3'
        }`}
        onClick={() => setIsShowNews(true)}
      >
        <EllipsisIcon size={24} color="#aaacaf" />
      </div>
    </div>
  );
}

RcentNewsCard.propTypes = {};

export default RcentNewsCard;
